'use client';

import { useEffect } from 'react';

// Registers /sw.js in production only. In dev, a SW would cache /_next and
// fight HMR, so we skip it — and we actively EVICT any worker already
// installed on this origin. A SW registered by an earlier local production
// run persists per-origin forever, and sw.js is cache-first on
// /_next/static/: dev chunk URLs are stable names with changing content, so
// a lingering worker pins the app at whatever vintage it first cached and
// every reload silently serves stale code. Failure is non-fatal.
export default function ServiceWorkerRegistrar() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      navigator.serviceWorker?.getRegistrations?.()
        .then((rs) => rs.forEach((r) => { void r.unregister(); }))
        .catch(() => { /* best-effort */ });
      if (typeof caches !== 'undefined') {
        caches.keys().then((ks) => ks.forEach((k) => { void caches.delete(k); })).catch(() => { /* best-effort */ });
      }
      return;
    }
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* registration is best-effort */
    });
  }, []);
  return null;
}
